import { RemarkInputType, type ProductSeatsResponse } from '@/view-models/remark'

export function useSeatRemark() {
  const i18n = useI18n()

  function getSeatRemark(seats: ProductSeatsResponse[]) {
    return {
      id: new Date().getTime(),
      type: RemarkInputType.Radio,
      title: i18n.t('payment_preferred_seat_title'),
      subtitle: '',
      placeholder: i18n.t('payment_preferred_seat_placeholder'),
      content: '',
      is_required: true,
      last_input: null,
      opt_default_idx: null,
      ruleOption: {
        required: true,
        email: false,
      },
      opt: seats.map(seat => ({
        id: seat.seat_id,
        value: seat.seat_name,
        langForUsen: seat.lang_for_usen,
      })),
    }
  }

  return {
    getSeatRemark,
  }
}
